import React from "react";
import { Modal, Button } from "react-bootstrap";
import './ModalDisplay.scss';

function ModalDisplay(props) {
	const { isVisible, headerText, contentText, confirmButtonText, disableConfirmButton, onCancel, onConfirm, hideButtons, size, color } = props;
	const { state } = props;

	let items = [];
	if (state) {
		const profiles = state.profiles.filter(profile => profile.enabled === false);
		const medias = state.medias.filter(profile => profile.enabled === false);
		const urls = state.urls.filter(profile => profile.enabled === false);
		items = [...profiles, ...medias, ...urls];
	}

	let buttons;
	if (!hideButtons) {
		buttons = <ConfirmationButtons disableConfirmButton={disableConfirmButton} confirmButtonText={confirmButtonText} onCancel={onCancel} onConfirm={onConfirm} color={color} />
	}

	let modalSize = size;
	if (!modalSize) {
		modalSize = "md";
	}

	return (
		<Modal size={modalSize} show={isVisible} onHide={() => { onCancel() }}>
			{
				headerText && <Modal.Header>{headerText}</Modal.Header>
			}
			<Modal.Body className="text-center mt-3">
				<p className="mb-0">{contentText}</p>
				{items.map((item, index) => (
					<div key={index} className="mb-2 mt-2 font-weight-bold">
						{item.name}
					</div>
				))}
			</Modal.Body>
			{buttons}
		</Modal>
	);
}

function ConfirmationButtons({ disableConfirmButton, confirmButtonText, onCancel, onConfirm, color }) {

	return (
		<Modal.Footer className="d-flex justify-content-center">
			<Button
				type="button"
				variant="outline-dark"
				onClick={() => { onCancel() }}>
				Cancel
			</Button>{" "}
			<Button
				variant={color}
				onClick={() => { onConfirm() }}
				disabled={disableConfirmButton}>
				{confirmButtonText}
			</Button>
		</Modal.Footer>
	);
}
export default ModalDisplay;
